module.exports = __webpack_public_path__ + "img/katarina_outside_8.c8501ffb.jpg";